import Founders from '../components/details/founder'
import React from 'react'

function Founder() {
  return (
    <Founders />
  )
}

export default Founder